exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ledes-code-set[data-v-70e180c0] {\n  max-height: 72vh;\n  overflow-y: scroll;\n}\n", ""]);

// exports
